/*
All assets, designs, and code related to this Lash AR Try-On Module, including but not limited to 3D models, textures, and scripts, are the intellectual property of xochiworld OÜ.
Unauthorized use, reproduction, or distribution is strictly prohibited without explicit permission from xochiworld OÜ.
*/

const ASSET_PATHS = {
  lashData: 'https://cdn.shopify.com/s/files/1/0660/8646/9831/files/lash_try_on_data.json',  
  model: 'https://cdn.shopify.com/3d/models/b57532cad02558d4/lash_v7.glb',
  textureBasePath: 'https://cdn.shopify.com/s/files/1/0660/8646/9831/files/',
  imageBasePath: 'https://cdn.shopify.com/s/files/1/0660/8646/9831/files/'
};


class OneEuroFilter {
  constructor(freq, minCutoff = 1.0, beta = 0.0, dcutoff = 1.0) {
    this.freq = freq;
    this.minCutoff = minCutoff;
    this.beta = beta;
    this.dcutoff = dcutoff;

    this.xPrev = null;
    this.dxPrev = 0;
    this.lastTime = performance.now();
  }

  alpha(cutoff) {
    const te = 1.0 / this.freq;
    const tau = 1.0 / (2 * Math.PI * cutoff);
    return 1.0 / (1.0 + tau / te);
  }

  filter(value) {
    const now = performance.now();
    const dt = (now - this.lastTime) / 1000.0;
    this.freq = 1.0 / dt;
    this.lastTime = now;

    let dx = 0.0;
    let xHat = value;

    if (this.xPrev !== null) {
      dx = (value - this.xPrev) * this.freq;
      const edx = this.exponentialSmoothing(dx, this.dxPrev, this.alpha(this.dcutoff));
      const cutoff = this.minCutoff + this.beta * Math.abs(edx);
      const alpha = this.alpha(cutoff);
      xHat = this.exponentialSmoothing(value, this.xPrev, alpha);
      this.dxPrev = edx;
    }

    this.xPrev = xHat;

    return xHat;
  }

  exponentialSmoothing(a, b, alpha) {
    return alpha * a + (1 - alpha) * b;
  }
}

const SimulationController = {
  init () {
    //console.log("Initializing scene...");
    this.landmarkIndices = [159, 386, 133, 33, 263, 362];
    this.smoothedLandmarks = {};
    this.filters = {};

// Initialize filters only for these landmarks
this.landmarkIndices.forEach(index => {
  this.filters[index] = {
    x: new OneEuroFilter(60, 2.5, 0.7, 1.0),
    y: new OneEuroFilter(60, 2.5, 0.7, 1.0),
    z: new OneEuroFilter(60, 2.5, 0.7, 1.0)
  };
});
    this.selectedLash = null
    this.defaultLash = { name: 'Violet', id: "8178230493383", handle: "violet-subtle-charm" }
    this.defaultSet = false
    this.lashesOnScene = false;
    this.debugMode = true
    this.pos = 0
    this.videoWidth = 240
    this.videoHeight = 320
    this.isMobile = /IEMobile|Windows Phone|Lumia|iPhone|iPad|iPod|Android|Blackberry|Playbook|BB10|Mobile Safari|webOs|Mobile|Tablet|Opera Mini|Opera Mobi/i.test(navigator.userAgent)
    this.tryOnStartTime = null
    this.maxDuration = 30 * 60 * 1000
    this.sessionDuration = 0
    this.sessionTimer = null
    this.isTryOnStarted = false
    this.setupScene();
    this.loadModels();
    this.createLashOptions()
    this.startRenderLoop();
    this.setUpUI()
    window.addEventListener('beforeunload', this.reportDuration.bind(this));

  },
  setUpUI () {
    this.landmarkCanvas = document.getElementById('landmarkCanvas');

    const loading = document.getElementById('loading');
    const overlay = document.getElementById('overlay');
    const app = document.getElementById('app');
    const actionButtons = document.getElementById('action-buttons')
    const header = document.getElementById('header')
    const subheader = document.getElementById('subheader')
    const instructions = document.getElementById('instructions')
    const videoContainer = document.getElementById('videocontainer')
    const column3 = document.getElementById('column-3')
    const privacyLink = document.getElementById('privacy-link')

    if (this.isMobile) {
      overlay.style.display = 'none'; // Hide overlay on mobile
      app.style.flexWrap = 'wrap';    // Enable flex-wrap for mobile devices
    } else {
      app.style.flexWrap = 'nowrap';  // Disable flex-wrap for larger screens
    }
    window.addEventListener('video-playing', (e) => {
      if (!this.isTryOnStarted) {
        this.startTryOnTimer();
      }
      this.video = e.detail.video;
      this.startMediaPipe();
      this.adjustRenderer(this.renderer);
      loading.style.display = 'none';
      actionButtons.style.display = 'flex';
      instructions.style.display = 'flex'
      if (!this.isMobile) {
        overlay.style.display = 'none';
        subheader.innerHTML = "Pick a spot with great light to get the most out of your experience."
        subheader.style.display = 'flex'
      } else {
        header.innerHTML = 'LASH MAKEOVER'
      }
      videoContainer.style.display = 'block';  // Show video container
      column3.style.display = 'flex';
    });

    window.addEventListener('resize', () => {
      this.adjustCanvasSizes();
      this.adjustRenderer(this.renderer);

    });

    window.addEventListener('modelsLoaded', () => {
      this.modelsLoaded = true
      //console.log('models loaded')
      if (this.elementsReady) {
        this.setDefault()
      }
    })

    const actionButton = document.getElementById('action-button');
    actionButton.addEventListener('click', (e) => {
      if (!this.consentApproved) {
        if (window.dataLayer) window.dataLayer.push({ event: `Event: Enter Try-On` })
        privacyLink.style.display = 'flex'
        subheader.innerHTML = "When you use our virtual try-on feature, we do not collect, store, or share any of your personal information or images.<br><br>All processing is done in real - time directly on your device.<br><br>By using our virtual try-on tool, you consent to the processing of your image solely for the duration of your session."
        actionButton.innerHTML = "CONTINUE"
        this.consentApproved = true
        return
      }
      if (!this.start) {
        if (window.dataLayer) window.dataLayer.push({ event: `Event: Consent Approved` })
        privacyLink.style.display = 'none'
        subheader.innerHTML = "To get started, please enable camera access and pick a spot with great light to get the most out of your experience."
        actionButton.innerHTML = "I'M READY"
        this.start = true
        return
      }
      if (window.dataLayer) window.dataLayer.push({ event: `Event: User is Ready` })
      this.setupVideo();
      subheader.style.display = 'none'
      actionButton.style.display = 'none'
      loading.style.display = 'flex';
    });

    const viewProductButton = document.getElementById('view-product-button');
    viewProductButton.addEventListener('click', (e) => {
      const parts = viewProductButton.href.split('/'); // Split the URL by '/'
      const handle = parts[parts.length - 1]; // Get the last part which is the handle

      if (window.dataLayer) window.dataLayer.push({ event: `Event: View Product: ${handle}` })

      window.open(viewProductButton.href)
    })
  },
  startTryOnTimer () {
    this.tryOnStartTime = Date.now();
    this.isTryOnStarted = true;

    if (window.dataLayer) {
      window.dataLayer.push({ event: `Event: Try-On Started` });
    }

    this.sessionTimer = setTimeout(() => {
      this.endSession();
    }, this.maxDuration);
  },
  endSession () {

    if (window.dataLayer) window.dataLayer.push({ event: `>30 Min Session` })

    this.isTryOnStarted = false;

    clearTimeout(this.sessionTimer);
  },
  reportDuration () {
    if (!this.isTryOnStarted) return;

    const tryOnEndTime = Date.now();
    let timeSpent = tryOnEndTime - this.tryOnStartTime;

    if (timeSpent < this.maxDuration) {
      const timeSpentInMinutes = Math.round(timeSpent / (1000 * 60));

      if (window.dataLayer) window.dataLayer.push({ event: `Session Time ${timeSpentInMinutes}` })
    }
  },
  setupScene () {
    //console.log("Setting up scene...");
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000); // Aspect ratio set to 1
    this.camera.position.z = 2;

    this.renderer = new THREE.WebGLRenderer({ alpha: true, canvas: document.getElementById('threejsCanvas') });
    this.renderer.setClearColor(0x000000, 0);
    this.renderer.outputEncoding = THREE.sRGBEncoding;

    const light = new THREE.AmbientLight(0xffffff);
    this.scene.add(light);

    this.leftLashModel = null;
    this.rightLashModel = null;
  },
  loadModels () {
    const lashPath = ASSET_PATHS.model
    //console.log("Loading models...");
    const loader = new THREE.GLTFLoader();

    let leftLoaded = false;
    let rightLoaded = false;

    // Helper function to emit an event when both models are loaded
    const checkIfBothLoaded = () => {
      if (leftLoaded && rightLoaded) {
        const event = new Event('modelsLoaded'); // Create a custom event
        window.dispatchEvent(event); // Emit the event
        //console.log('Both models are loaded');
      }
    };

    loader.load(lashPath, (gltf) => {
      // Left Lash
      this.leftLashModel = gltf.scene; // Clone for left lash
      this.leftLashModel.position.set(0, 0, 0); // Set initial position
      this.leftLashModel.scale.set(1, 1, 1);
      this.leftLashModel.name = 'LeftLash';
      leftLoaded = true;
      checkIfBothLoaded(); // Check if both models are loaded
    }, undefined, (error) => {
      console.error("Error loading models:", error);
    });

    loader.load(lashPath, (gltf) => {
      // Right Lash
      this.rightLashModel = gltf.scene; // Clone for right lash
      this.rightLashModel.position.set(0, 0, 0); // Set initial position (adjust as needed)
      this.rightLashModel.scale.set(1, 1, 1);
      this.rightLashModel.name = 'RightLash';
      rightLoaded = true;
      checkIfBothLoaded(); // Check if both models are loaded
    }, undefined, (error) => {
      console.error("Error loading models:", error);
    });
  },
  getLashData () {
    return fetch(ASSET_PATHS.lashData)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
      });
  },
  async createLashOptions () {
    const container = document.getElementById('lash-options-container');
    const data = await this.getLashData();  // Fetch the data
    const lashes = data.lashes;  // Access the 'lashes' object
    const lashesLength = Object.keys(lashes).length;  // Get the number of keys (i.e., number of lash options)

    let lashOptions = 0
    for (const lashName in lashes) {

      const lash = lashes[lashName];
      const imgPath = `${ASSET_PATHS.imageBasePath}${lashName.toLowerCase()}_AR_img.jpg`;

      // Create a wrapper div for each lash option
      const lashWrapper = document.createElement('div');
      lashWrapper.className = 'lash-wrapper';

      // Create the product name element (use lash.handle or a more readable name)
      const productName = document.createElement('h4');
      productName.className = 'product-name';
      productName.innerText = lashName;  // Display the lash name (or handle if preferred)

      // Create button for each lash style image
      const lashButton = document.createElement('button');
      lashButton.className = 'lash-option';
      lashButton.id = lashName
      lashButton.style.backgroundImage = `url(${imgPath})`; // Set image as background

      // Add click event to change the lash texture and update the product link
      lashButton.addEventListener('click', () => {
        this.setSelectedLash(lash);  // Pass the lash object
        this.changeLashTexture(lashName);
        this.setViewProductURL(lash.handle);
      });

      // Append the product name and lash image button to the wrapper
      lashWrapper.appendChild(productName);  // Add the product name on top
      lashWrapper.appendChild(lashButton);

      container.appendChild(lashWrapper);

      lashOptions++

      if (lashOptions == lashesLength) {
        this.elementsReady = true
      }


      if (this.modelsLoaded) {
        this.setDefault()
      }
    }
  },
  setViewProductURL (handle) {
    const productUrl = `https://cocolashco.myshopify.com/products/${handle}`;  // Construct the product link
    const viewProductButton = document.getElementById('view-product-button');
    viewProductButton.href = productUrl
  },
  setDefault () {
    if (this.defaultSet) { return }
    this.changeLashTexture(this.defaultLash.name);
    this.setViewProductURL(this.defaultLash.handle)
    this.setSelectedLash(this.defaultLash)
    this.defaultSet = true
  },
  setSelectedLash (lash) {
    if (this.selectedLash) {
      const prevLashEl = document.getElementById(this.selectedLash.name);
      if (prevLashEl) {
        prevLashEl.classList.remove('selected');
      }
    }
    this.selectedLash = lash;
    if (window.dataLayer) window.dataLayer.push({ event: `Event: ${this.selectedLash.name} Set Tried` })
    const lashEl = document.getElementById(lash.name);
    if (lashEl) {
      lashEl.classList.add('selected');
    }
  },
  changeLashTexture (lashName) {
    const texturePath = `${ASSET_PATHS.textureBasePath}${lashName.toLowerCase()}_AR_texture.png`;
    const loader = new THREE.TextureLoader();
    loader.load(texturePath, (texture) => {
      if (this.leftLashModel && this.rightLashModel) {
        this.leftLashModel.traverse((child) => {
          if (child.isMesh) {
            this.updateLashTexture(child, texture)
          }
        });
        this.rightLashModel.traverse((child) => {
          if (child.isMesh) {
            this.updateLashTexture(child, texture)
          }
        });
      }
    }, undefined, (error) => {
      console.error('Error loading texture:', error);
    });
  },
  updateLashTexture (child, texture) {
    child.material.map = texture;
    child.material.alphaMap = texture;
    child.material.opacity = 1
    child.material.color.set(0x000000);
    child.material.transparent = true;
    child.material.needsUpdate = true;
  },
  startMediaPipe () {
    const faceMesh = new FaceMesh({
      locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`
    });

    faceMesh.setOptions({
      maxNumFaces: 1,
      refineLandmarks: true,
      minDetectionConfidence: 0.7,
      minTrackingConfidence: 0.7,
    });

    faceMesh.onResults(this.onResults.bind(this));

    const camera = new Camera(this.video, {
      onFrame: async () => {
        await faceMesh.send({ image: this.video });
      },
      width: this.videoWidth,
      height: this.videoHeight
    });
    camera.start();
  },
  onResults (results) {
    if (results.multiFaceLandmarks && results.multiFaceLandmarks.length > 0) {
      const landmarks = results.multiFaceLandmarks[0];

      // Apply smoothing
      this.smoothLandmarksOneEuro(landmarks);

      if (!this.lashesOnScene) {
        this.lashesOnScene = true;
        this.lashesVisible = true;
        this.scene.add(this.leftLashModel);
        this.scene.add(this.rightLashModel);
      }
      if (!this.lashesVisible) {
        this.leftLashModel.visible = true;
        this.rightLashModel.visible = true;
      }

      // Use smoothed landmarks
      this.calibrateLashesToEyes(this.smoothedLandmarks);
    } else {
      if (this.lashesVisible) {
        this.leftLashModel.visible = false;
        this.rightLashModel.visible = false;
        this.lashesVisible = false;
      }
    }
  },
  smoothLandmarksOneEuro (newLandmarks) {
    const now = Date.now();
    if (!this.smoothedLandmarks || Object.keys(this.smoothedLandmarks).length === 0) {
      // Initialize smoothedLandmarks for the used indices
      this.landmarkIndices.forEach(i => {
        if (newLandmarks[i]) { // Ensure the landmark exists
          this.smoothedLandmarks[i] = { ...newLandmarks[i] };
          // Initialize lastTime for filters
          this.filters[i].x.lastTime = now;
          this.filters[i].y.lastTime = now;
          this.filters[i].z.lastTime = now;
        }
      });
    } else {
      this.landmarkIndices.forEach(i => {
        if (this.filters[i] && newLandmarks[i]) {
          this.smoothedLandmarks[i].x = this.filters[i].x.filter(newLandmarks[i].x);
          this.smoothedLandmarks[i].y = this.filters[i].y.filter(newLandmarks[i].y);
          this.smoothedLandmarks[i].z = this.filters[i].z.filter(newLandmarks[i].z);
        }
      });
    }
  },
  smoothLandmarks (newLandmarks) {
    const alpha = 0.7;
    if (this.smoothedLandmarks.length === 0) {
      this.smoothedLandmarks = newLandmarks.map(point => ({ ...point }));
    } else {
      for (let i = 0; i < newLandmarks.length; i++) {
        this.smoothedLandmarks[i].x = alpha * newLandmarks[i].x + (1 - alpha) * this.smoothedLandmarks[i].x;
        this.smoothedLandmarks[i].y = alpha * newLandmarks[i].y + (1 - alpha) * this.smoothedLandmarks[i].y;
        this.smoothedLandmarks[i].z = alpha * newLandmarks[i].z + (1 - alpha) * this.smoothedLandmarks[i].z;
      }
    }
  },
  calibrateLashesToEyes (landmarks) {
    if (
      landmarks[159] && landmarks[386] &&
      landmarks[133] && landmarks[33] &&
      landmarks[263] && landmarks[362]
    ) {
      // Choose landmarks that represent the lashline above the eye
      const leftLashPoint = landmarks[159];  // Left eye top
      const rightLashPoint = landmarks[386]; // Right eye top

      // Convert normalized coordinates to NDC space [-1, 1]
      const yoffset = 0.0065
      const xoffset = -0.008
      const leftNDC = new THREE.Vector3(
        leftLashPoint.x * 2 - 1 - xoffset,
        - (leftLashPoint.y * 2 - 1 + yoffset),
        0 // Set depth in NDC space
      );

      const rightNDC = new THREE.Vector3(
        rightLashPoint.x * 2 - 1 + xoffset,
        - (rightLashPoint.y * 2 - 1 + yoffset),
        0
      );

      // Unproject NDC coordinates to world coordinates
      leftNDC.unproject(this.camera);
      rightNDC.unproject(this.camera);

      // Update positions
      if (this.leftLashModel && this.rightLashModel) {
        this.leftLashModel.position.copy(leftNDC);
        this.rightLashModel.position.copy(rightNDC);

        // Handle scaling and rotation
        this.adjustLashScaleAndRotation(landmarks);
      }
    }
  },
  adjustLashScaleAndRotation (landmarks) {
    // Left eye
    const leftInnerCorner = landmarks[133];
    const leftOuterCorner = landmarks[33];
    const leftEyeWidth = this.distanceBetweenPoints(leftInnerCorner, leftOuterCorner);
    const leftScaleFactor = leftEyeWidth * 15; // Adjust the multiplier as needed

    // Right eye
    const rightInnerCorner = landmarks[263];
    const rightOuterCorner = landmarks[362];
    const rightEyeWidth = this.distanceBetweenPoints(rightInnerCorner, rightOuterCorner);
    const rightScaleFactor = rightEyeWidth * 15; // Adjust the multiplier as needed

    // Update scales
    this.leftLashModel.scale.set(leftScaleFactor, leftScaleFactor, leftScaleFactor);
    this.rightLashModel.scale.set(rightScaleFactor, rightScaleFactor, rightScaleFactor);

    this.leftLashModel.scale.x *= -1;

    // Handle rotations
    this.handleLashRotation(this.leftLashModel, leftInnerCorner, leftOuterCorner, false);
    this.handleLashRotation(this.rightLashModel, rightInnerCorner, rightOuterCorner, true);
  },
  handleLashRotation (lashModel, innerCorner, outerCorner, isRightLash) {
    // Calculate the angle between the inner and outer corners
    let eyeAngle = Math.atan2(
      outerCorner.y - innerCorner.y,
      outerCorner.x - innerCorner.x
    );

    const tiltDegrees = 20; // Adjust this value between 0 and 180
    const tiltRadians = THREE.MathUtils.degToRad(tiltDegrees);
    const tilt = Math.PI - tiltRadians;
    const spinDegrees = 10; // Adjust this value between 0 and 180
    const spinRadians = THREE.MathUtils.degToRad(spinDegrees);
    let spin = spinRadians;
    if (isRightLash) {
      spin = -spin
    }

    lashModel.rotation.set(tilt, spin, eyeAngle);
  },
  startRenderLoop () {
    const renderLoop = () => {
      requestAnimationFrame(renderLoop);
      this.renderer.render(this.scene, this.camera);
    };
    renderLoop();
  },
  adjustCanvasSizes () {
    const videoContainer = document.getElementById('videocontainer');
    const containerWidth = videoContainer.clientWidth;
    const containerHeight = videoContainer.clientHeight;

    this.landmarkCanvas.width = containerWidth;
    this.landmarkCanvas.height = containerHeight;

    // Adjust the renderer size
    this.renderer.setSize(containerWidth, containerHeight);

    // Adjust the camera's aspect ratio and update the projection matrix
    this.camera.aspect = containerWidth / containerHeight;
    this.camera.updateProjectionMatrix();
  },
  adjustRenderer (renderer) {
    const videoContainer = document.getElementById('videocontainer');
    const containerWidth = videoContainer.clientWidth;
    const containerHeight = videoContainer.clientHeight;

    renderer.setSize(containerWidth, containerHeight);

    // Adjust the camera's aspect ratio and update the projection matrix
    this.camera.aspect = containerWidth / containerHeight;
    this.camera.updateProjectionMatrix();
  },
  setupVideo () {
    //console.log("Setting up video...");
    const video = document.getElementById('videostream');

    const constraints = {
      video: {
        facingMode: 'user',
        width: { ideal: 720 },
        height: { ideal: 720 },
      }
    };

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      video.srcObject = stream;

      video.onloadedmetadata = () => {
        //console.log("Video metadata loaded.");

        // Update video dimensions
        this.videoWidth = video.videoWidth;
        this.videoHeight = video.videoHeight;

        video.play().then(() => {
          // console.log("Video playing.");
          window.dispatchEvent(new CustomEvent('video-playing', { detail: { video: video } }));
          this.adjustCanvasSizes();
        }).catch((error) => {
          console.error("Error playing video:", error);
        });
      };
    }).catch((err) => {
      console.error("Error accessing the camera:", err);
    });
  },
  averagePoints (points) {
    let avgX = 0;
    let avgY = 0;
    points.forEach(point => {
      avgX += point.x;
      avgY += point.y;
    });
    return { x: avgX / points.length, y: avgY / points.length };
  },
  distanceBetweenPoints (point1, point2) {
    return Math.sqrt(
      Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2)
    );
  },
  angleBetweenPoints (point1, point2) {
    return Math.atan2(point2.y - point1.y, point2.x - point1.x);
  },
  drawLandmarksOnCanvas (results, landmarks) {
    // Draw landmarks
    const canvasCtx = this.landmarkCanvas.getContext('2d');
    canvasCtx.save();
    canvasCtx.clearRect(0, 0, this.landmarkCanvas.width, this.landmarkCanvas.height);

    // Draw the video frame (if you want to overlay the landmarks on the video)
    canvasCtx.drawImage(results.image, 0, 0, this.landmarkCanvas.width, this.landmarkCanvas.height);

    // Left eye landmark indices
    const leftEyeIndices = [133, 159, 33];

    // Right eye landmark indices
    const rightEyeIndices = [362, 386, 263];

    // Draw left eye landmarks
    drawLandmarks(
      canvasCtx,
      leftEyeIndices.map(i => landmarks[i]),
      { color: '#30FF30', lineWidth: 0.01, radius: 1 }
    );

    // Draw right eye landmarks
    drawLandmarks(
      canvasCtx,
      rightEyeIndices.map(i => landmarks[i]),
      { color: '#30FF30', lineWidth: 0.01, radius: 1 }
    );
    canvasCtx.restore();
  }
};

document.addEventListener('DOMContentLoaded', function() {
  SimulationController.init();
});

/*
All assets, designs, and code related to this Lash AR Try-On Module, including but not limited to 3D models, textures, and scripts, are the intellectual property of xochiworld OÜ.
Unauthorized use, reproduction, or distribution is strictly prohibited without explicit permission from xochiworld OÜ.
*/